<div class="er-page er-matdark er-bbps-elec">
    <div class="er-page-head">
        <p class="er-eyebrow">BBPS · Electricity</p>
        <h1 class="er-page-title">Electricity bill payment</h1>
    </div>

    <div class="er-card er-bbps-section">
        <section class="example-section">
            <mat-radio-group (change)="selectype($event.value)" [(ngModel)]="labelPosition">
                <mat-radio-button class="example-margin" value="elc">Electricity boards</mat-radio-button>
                <mat-radio-button class="example-margin" value="apart">Apartments</mat-radio-button>
            </mat-radio-group>
        </section>
    </div>

    <div class="er-card er-bbps-section" *ngIf="showSlap">
        <form [formGroup]="electricityForm">
            <div class="row">
                <div>
                    <mat-form-field appearance="outline">
                        <mat-label><strong>Select state *</strong></mat-label>
                        <mat-select placeholder="Select State" formControlName="state" [errorStateMatcher]="matcher">
                            <mat-option *ngFor="let state of states" [value]="state">{{state}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="electricityForm.hasError('required','state')">
                            state required
                        </mat-error>
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field appearance="outline">
                        <mat-label><strong>Select board</strong></mat-label>
                        <mat-select placeholder="Select Board" formControlName="board" [errorStateMatcher]="matcher">
                            <mat-option *ngFor="let state of states" [value]="state">{{state}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="electricityForm.hasError('required','board')">
                            board required
                        </mat-error>
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field appearance="outline">
                        <mat-label><strong>Select district/type</strong> </mat-label>
                        <mat-select placeholder="Select District/type" formControlName="district"
                            [errorStateMatcher]="matcher">
                            <mat-option *ngFor="let state of states" [value]="state">{{state}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="electricityForm.hasError('required','district')">
                            district required
                        </mat-error>
                    </mat-form-field>
                </div>

            </div>
            <div class="row">
                <div>
                    <mat-form-field appearance="outline">
                        <mat-label><strong>Account number</strong> </mat-label>
                        <input matInput type="number" placeholder="End Range" formControlName="acountNo"
                            [errorStateMatcher]="matcher">
                        <mat-error *ngIf="electricityForm.hasError('required','acountNo')">
                            Acount Number required
                        </mat-error>
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field appearance="outline">
                        <mat-label><strong>Mobile number</strong> </mat-label>
                        <input matInput type="number" placeholder="End Range" formControlName="mobile"
                            [errorStateMatcher]="matcher">
                        <mat-error *ngIf="electricityForm.hasError('required','mobile')">
                            Mobile Number required
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div>
                    <button class="er-btn er-btn--primary" type="submit">Submit</button>
                </div>

            </div>
        </form>
    </div>
    <div class="er-card er-bbps-section" *ngIf="!showSlap">
        <form [formGroup]="ApartmentForm">
            <div class="row">
                <div>
                    <mat-form-field appearance="outline">
                        <mat-label><strong>Select city *</strong></mat-label>
                        <mat-select placeholder="Select city" formControlName="city" [errorStateMatcher]="matcher">
                            <mat-option *ngFor="let state of states" [value]="state">{{state}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="ApartmentForm.hasError('required','city')">
                            city required
                        </mat-error>
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field appearance="outline">
                        <mat-label><strong>Select apartment</strong></mat-label>
                        <mat-select placeholder="Select apartment" formControlName="apartment"
                            [errorStateMatcher]="matcher">
                            <mat-option *ngFor="let state of states" [value]="state">{{state}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="ApartmentForm.hasError('required','apartment')">
                            apartment required
                        </mat-error>
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field appearance="outline">
                        <mat-label><strong>Account number</strong> </mat-label>
                        <input matInput type="number" placeholder="Account Number" formControlName="acountNo"
                            [errorStateMatcher]="matcher">
                        <mat-error *ngIf="ApartmentForm.hasError('required','acountNo')">
                            Acount Number required
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">

                <div>
                    <mat-form-field appearance="outline">
                        <mat-label><strong>Mobile number</strong> </mat-label>
                        <input matInput type="number" placeholder="Mobile Number" formControlName="mobile"
                            [errorStateMatcher]="matcher">
                        <mat-error *ngIf="ApartmentForm.hasError('required','mobile')">
                            Mobile Number required
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div>
                    <button class="er-btn er-btn--primary" type="submit">Submit</button>
                </div>

            </div>
        </form>
    </div>
</div>
